import { React, Heading, Text, Steps, Row, Col, Button } from "mondrian-react";
import PhoneStep from "components/PhoneStep";
import AuthenticationStep from "components/AuthenticationStep";
import { logger } from "utils/logger";
import FaturaStep from "components/FaturaStep";
import PaymentCodeBar from "components/PaymentCodeBar";
import PaymentPix from "components/PaymentPix";
import PhoneError from "components/PhoneError";
import { isMobile } from "react-device-detect";
import Alert from "components/Alert";
import FaturaEmpty from "components/FaturaEmpty";
import { reportGA4 } from "utils/pushDataLayer";
import useIsPJ from "hooks/useIsPJ";

import "./styles.scss";

const FaturaForm = ({
  currentStep,
  handleCodeAuthentication,
  authenticationStepProps,
  handleButtonVoltar,
  listInvoices,
  isPhoneError,
  lineSelected,
  isEmpty,
  changeNumberMsisdn
}) => {
  const [inputLineNumber, setLineNumber] = React.useState("");
  const [paymentCodeBarOpen, setPaymentCodeBarOpen] = React.useState(false);
  const [faturaSelect, setFaturaSelect] = React.useState({});
  const [paymentPixOpen, setPaymentPixOpen] = React.useState(false);
  const isPJ = useIsPJ();

  const [steps, setSteps] = React.useState([
    {
      title: "Celular",
      status: "doing",
    },
    {
      title: isMobile ? "Código" : "Código de segurança",
      status: "todo",
    },
    {
      title: "Faturas",
      status: "todo",
    },
  ]);
  const recaptchaRef = React.createRef();
  const [codeBarAlert, setCodeBarAlert] = React.useState(false);

  React.useEffect(() => {
    setLineNumber(lineSelected);
  }, [lineSelected]);

  //Verifica se o número está no formato correto
  const isDisabled = inputLineNumber.replace(/[^0-9]/g, "").length !== 11;

  const dataCodeAuthentication = () => {
    logger({ name: "OpenModalToken" });
    const msisdn = inputLineNumber;
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(process.env.REACT_APP_RECAPTCHA_CLIENT, {
          action: "validate_captcha",
        })
        .then(function (tokenRecaptcha) {
          handleCodeAuthentication(msisdn, tokenRecaptcha);
        });
    });
  };

  const phoneStepProps = {
    propsLineNumber: {
      onChange: ({ target }) => setLineNumber(target.value),
      value: inputLineNumber
    },

    propsButtonSubmit: {
      disabled: isDisabled,
      onClick: () => {
        dataCodeAuthentication()
        reportGA4({ customTitle: 'validacao_do_numero:continuar' })
      },
    },
    recaptchaRef: recaptchaRef,
    // verifyCallback,
  };

  const faturaStepProps = {
    changeNumber: () => {
      setLineNumber("");
      handleButtonVoltar();
    },
    setCodeBarAlert,
    setPaymentCodeBarOpen,
    setFaturaSelect,
    setPaymentPixOpen,
    numberPhone: inputLineNumber,
    optionsFatura: listInvoices,
    changeNumberMsisdn
  };

  React.useEffect(() => {
    let newStepsState = [];
    steps.forEach((_step, index) => {
      if (currentStep > index) {
        newStepsState.push({
          ..._step,
          status: "active",
        });
      } else if (currentStep === index) {
        newStepsState.push({
          ..._step,
          status: "doing",
        });
      } else {
        newStepsState.push({
          ..._step,
          status: "todo",
        });
      }
    });
    setSteps(newStepsState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);

  return (
    <>
      {(paymentCodeBarOpen || paymentPixOpen) ? (<Row>
        <Col xs={12} className="mdn-u-marginTop--sm mdn-u-marginBottom--sm">
          <Button secondary href={"#"} onClick={() => { setPaymentPixOpen(false); setPaymentCodeBarOpen(false); }}>Voltar</Button>
        </Col>
      </Row>) : null}

      <Row className={'ff-heading'}>
        <Col xs={12}>
          <Heading xl>Fatura Fácil</Heading>
          <Text body>
            Acesse a 2ª via de suas faturas de forma rápida e segura.
          </Text>
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={10} className="mdn-Offset-lg-1">
          <Steps default data={steps} className='divStep' />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div className={`mcm-FaturaForm ${!isPJ ? 'mdn-u-marginBottom--lg' : ''}`}>
            {codeBarAlert ? (
              <Alert
                text={
                  paymentPixOpen ? "Código Pix copiado!" : "Código de barras copiado!"
                }
                onClose={() => setCodeBarAlert(false)}
              />
            ) : null}
            <div className={"mcm-Content"}>
              {isEmpty ? <FaturaEmpty
                handleButtonClick={handleButtonVoltar}
                msisdn={inputLineNumber}
              /> :
                isPhoneError ? (
                  <PhoneError
                    handleButtonClick={handleButtonVoltar}
                    msisdn={inputLineNumber}
                    currentStep={currentStep}
                  />
                ) : paymentCodeBarOpen ? (
                  <PaymentCodeBar
                    fatura={faturaSelect}
                    goBack={() => {
                      setPaymentCodeBarOpen(false);
                    }}
                    setCodeBarAlert={setCodeBarAlert}
                  />
                ) : paymentPixOpen ? (
                  <PaymentPix
                    fatura={faturaSelect}
                    goBack={() => {
                      setPaymentPixOpen(false);
                    }}
                    setCodeBarAlert={setCodeBarAlert}
                  />
                ) : (
                  <>
                    {currentStep === 0 && <PhoneStep {...phoneStepProps} />}
                    {currentStep === 1 && (
                      <AuthenticationStep {...authenticationStepProps} />
                    )}
                    {currentStep === 2 && <FaturaStep {...faturaStepProps} />}
                  </>
                )}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default FaturaForm;
